const NEWSPAPER_PREFIX = 'AMPOSTER_NEWSPAPER_V1:';

const utf8ToBase64 = (value) => btoa(encodeURIComponent(value).replace(
  /%([0-9A-F]{2})/g,
  (_, hex) => String.fromCharCode(Number.parseInt(hex, 16)),
));

const base64ToUtf8 = (value) => decodeURIComponent(
  Array.from(atob(value), (character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
);

export const serializeNewspaper = (newspaper) => {
  const json = JSON.stringify(newspaper || {});
  return `${NEWSPAPER_PREFIX}${utf8ToBase64(json)}`;
};

export const parseNewspaper = (content) => {
  if (typeof content !== 'string' || !content.startsWith(NEWSPAPER_PREFIX)) return null;
  try {
    const value = JSON.parse(base64ToUtf8(content.slice(NEWSPAPER_PREFIX.length)));
    return value && Array.isArray(value.pages) ? value : null;
  } catch (_) {
    return null;
  }
};

export const findNewspaperCover = (newspaper) => {
  for (const page of newspaper?.pages || []) {
    for (const article of page?.articles || []) {
      for (const image of article?.images || []) {
        const url = image?.url || image?.dataUrl;
        if (typeof url === 'string' && /^https?:\/\//i.test(url)) return url;
      }
    }
  }
  return '';
};
